exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subtitle {\n  margin: 1rem auto;\n  color: #3040C4;\n}", ""]);

// exports
